import { memo } from 'react';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';

type Props = {
  model: CheckoutConfirmationResponseType['HeadlinesSubsection'];
};

export const CheckoutConfirmationHeadline = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.headline');

  return (
    <>
      {model.Headlines.map((item) => (
        <div key={item} className="confirmation-header HeaderTextColor">
          {item}
        </div>
      ))}

      <div className="process-time">
        <div>{model.ProcessedTimeLabel}</div>
        <div>
          {tHelper('confirmation', {
            id: model.ShowPaymentIDInsteadOfContributionID ? model.PaymentID : model.ContributionID,
          })}
        </div>
        {model.DisplayLicenseNumber && (
          <div>
            {tHelper('licenseNumber', {
              licenseNumber: `${model.LicenseNumber.slice(0, 4)}-${model.LicenseNumber.slice(4)}`,
            })}
          </div>
        )}
      </div>
    </>
  );
});
